import { Component, OnInit } from '@angular/core';
declare var $: any;
declare var jQuery: any;

@Component({
  selector: 'cat-page',
  templateUrl: './form-wizard.html'
})

export class FormsFormWizard implements OnInit {
  ngOnInit() {

    $(function() {

      $("#example-icons").steps({
        headerTag: "h3",
        bodyTag: "section",
        transitionEffect: "slideLeft",
        autoFocus: true
      });

      $("#example-numbers").steps({
        headerTag: "h3",
        bodyTag: "section",
        transitionEffect: "slideLeft",
        autoFocus: true
      });

    });

  }
}

